import { defaultAnchorSpec, type AnchorSpec, type Category } from '@ar-suite/core'
import type { ProceduralWristOptions } from './procedural'

export interface ProceduralWristProduct {
  id: string
  name: string
  category: Category
  procedural: Partial<ProceduralWristOptions>
  anchor: AnchorSpec
}

function spec(category: Category, patch: Partial<AnchorSpec> = {}): AnchorSpec {
  const s = defaultAnchorSpec(category)
  s.unitScale = 1
  return Object.assign(s, patch)
}

export const PROCEDURAL_WRIST: ProceduralWristProduct[] = [
  { id: 'watch-classic-gold', name: 'Watch · Classic gold', category: 'watch', procedural: { style: 'watch' }, anchor: spec('watch', { meta: { fitWidthCm: 5.8 } }) },
  { id: 'bangle-gold', name: 'Bangle · Gold', category: 'bracelet', procedural: { style: 'bangle' }, anchor: spec('bracelet') },
  { id: 'bangles-trio', name: 'Bangles · Trio', category: 'bracelet', procedural: { style: 'bangles' }, anchor: spec('bracelet', { meta: { fitWidthCm: 5.8 } }) },
]
